<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    v-if="visible"
    :width="width"
    :top="top"
    @close="hide()"
  >
    <div class="wrap" v-if="load">
      <el-tabs v-model="activeNames" @tab-click="change">
        <slot></slot>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <slot name="footer"></slot>
    </span>
  </el-dialog>
</template>

<script>

export default {
	name: 'TemplateDialog',
	props: {
		top: {
			type: String,
			default: '10vh'
		},
		width: {
			type: String,
			default: '90%'
		},
		load: {
			type: Boolean,
			default: true
		},
		title: {
			type: String,
			default: ''
		},
		dataList: {
			type: Array,
			default: () => []
		},
		activeName: {
			type: String,
			default: '0'
		}
	},
	data () {
		return {
			visible: false,
			activeNames: ''
		}
	},
	watch: {},
	async created () {
		this.active()
	},
	methods: {
		active () {
			this.activeNames = this.activeName
		},
		show () {
			this.$emit('update:load', true)
			this.active()
			this.visible = true
		},
		change (e) {
			console.log(e)
			this.$emit('change', e)
		},
		hide () {
			this.$emit('update:load', false)
			this.visible = false
		}
	}
}
</script>
<style lang="scss" scoped>
/deep/ {
  .el-tabs__content {
    height: 500px;
    padding-bottom: 20px;
    overflow-y: scroll;
  }

  .el-tab-pane {
    height: 100%;
    & > div {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      &.isScroll {
        overflow-y: scroll;
        &::-webkit-scrollbar-track {
          background: #fff;
        }
      }
    }
  }
  .filter-container {
    margin: 0;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  // .hidden {
  //   height: 100%;
  //   overflow-y: scroll;
  //   &::-webkit-scrollbar {
  //     width: 0 !important;
  //   }
  // }
}
</style>
